import { Component, Input, Output, OnInit, forwardRef, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { sortBy } from 'lodash';
import { settings } from 'app/app.settings';

@Component({
  selector: 'app-form-roles',
  templateUrl: './form-roles.component.html',
  styleUrls: ['./form-roles.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormRolesComponent),
      multi: true
    }
  ]
})
export class FormRolesComponent implements OnInit, ControlValueAccessor {
  @Input()  required = false;
  @Input()  disabled = false;
  @Input()  placeholder = '';
  @Output() change: EventEmitter<any>;

  content = [];
  roles = [];

  propagateChange = (_: any) => {};
  propagateTouch = (_: any) => {};

  constructor(
    private translateService: TranslateService
  ) {
    this.change = new EventEmitter();
    this.roles = this.getRoles();
  }

  ngOnInit() {
  }

  writeValue(value: any) {
    this.content = value;
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  onChange(event) {
    this.change.emit(event);
  }

  onModelChange(item: string) {
    this.propagateChange(item);
    this.propagateTouch(item);
  }

  getRoles() {
    const roles = settings.roles.map((key) => {
      return {
        id: key,
        name: this.translateService.instant('shared.role.' + key)
      };
    });

    return sortBy(roles, 'id');
  }
}
